import { render, staticRenderFns } from "./IgnoredLpfrsView.vue?vue&type=template&id=1edd5212&"
import script from "./IgnoredLpfrsView.vue?vue&type=script&lang=js&"
export * from "./IgnoredLpfrsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports